import {autoinject} from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { VoyageService } from "../../../../../services/voyage/voyage.service";
import { VoyageDeclarationResponse } from "../../../../../models/carbon-accounting/carbon-accounting.models";

@autoinject
export class DeclarationDialog {
    public voyageDeclaration: VoyageDeclarationResponse;

    constructor(private dialogClientService: DialogClientService, private voyageService: VoyageService) { }
    
    async activate(model: any) {
        if (model && model.voyageId)
            this.voyageDeclaration = await this.voyageService.getVoyageDeclaration(model.voyageId);
    }

    close() {
        this.dialogClientService.hide();
    }
}